import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export const atLeastOneCheckboxCheckedValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const groupValues = control.value;
	const hasAtLeastOne = Object.values(groupValues).some(value => value === true);

	return hasAtLeastOne ? null : { requireAtLeastOne: true };
};
